function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var InfoContainer = styled.div(_templateObject());
var Title = styled.h1(_templateObject1());
var Description = styled.p(_templateObject2(), function(props) {
    return props.theme.isDark ? '#9ca3af' : '#4b5563';
});
var MetaInfo = styled.div(_templateObject3(), function(props) {
    return props.theme.isDark ? '#6b7280' : '#6b7280';
});
export var ProjectInfo = function(param) {
    var title = param.title, description = param.description, author = param.author, createdAt = param.createdAt;
    var formattedDate = new Date(createdAt).toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    return /*#__PURE__*/ React.createElement(InfoContainer, null, /*#__PURE__*/ React.createElement(Title, null, title), /*#__PURE__*/ React.createElement(Description, null, description), /*#__PURE__*/ React.createElement(MetaInfo, null, /*#__PURE__*/ React.createElement("span", null, "작성자: ", author.name), /*#__PURE__*/ React.createElement("span", null, "•"), /*#__PURE__*/ React.createElement("span", null, formattedDate)));
};
export default ProjectInfo;
